import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { UserLayout } from 'components/layout/UserLayout'
import { DetailPageBar } from 'components/layout/PageBar'
import { useSprintPacket } from 'hooks/api/useSprintPackets'
import { PacketEditorBody } from './editor/PacketEditorBody'
import { usePacketFonts } from './usePacketFonts'

export function EditSprintPacket() {
  usePacketFonts()
  const { businessID, packetID } = useParams<{ businessID: string; packetID: string }>()
  const packetIDNum = Number(packetID)
  const { packet } = useSprintPacket(packetIDNum)

  // Carried-forward slides nobody has looked at yet. Deliberately shown here,
  // beside the Present button, and never inside Present itself — the client may
  // be in the room. It never blocks presenting.
  const unreviewedCount = (packet?.customSections ?? []).filter(s => s.needsReview).length

  return (
    <UserLayout>
      <DetailPageBar
        eyebrow="Sprint Packet"
        subject={packet?.sprint?.name ?? 'Sprint'}
        backTo={`/${businessID}/sprint-packets`}
        actions={
          <>
            {unreviewedCount > 0 && (
              <span className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-1.5 text-xs font-semibold text-amber-700">
                {unreviewedCount} slide{unreviewedCount === 1 ? '' : 's'} not reviewed
              </span>
            )}
            <Link
              to={`/${businessID}/sprint-packets/${packetID}/review`}
              className="inline-flex items-center gap-2 rounded-lg border border-mm-primary-600 px-4 py-2 text-sm font-semibold text-mm-primary-600 transition-colors hover:bg-mm-primary-50"
            >
              <i className="fa fa-check" />
              Review
            </Link>
            <Link
              to={`/${businessID}/sprint-packets/${packetID}/present`}
              className="inline-flex items-center gap-2 rounded-lg bg-mm-primary-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-mm-primary-700"
            >
              <i className="fa fa-play" />
              Present
            </Link>
          </>
        }
      />
      <PacketEditorBody businessID={Number(businessID)} packetID={packetIDNum} />
    </UserLayout>
  )
}
